import React from 'react';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../general-components/icon';

interface ScheduledStreamCommsModalProps {
	isLive: boolean;
	goToSettings: any;
	handleClick: any;
}

export default function ScheduledStreamCommsModal(props: ScheduledStreamCommsModalProps) {
	const {
		isLive,
		goToSettings,
		handleClick,
	} = props;

	return (
		<div className="broadcasting-start-overlay">
			<div className="broadcasting-start-modal">
				<h4>
					Backstage comms is off
				</h4>
				{isLive && (
					<p>
						All audio backstage is being sent to your audience right now.
						We strongly recommend you turn this back on.
					</p>
				)}
				{!isLive && (
					<p>
						All audio backstage will be sent to your audience once your scheduled stream begins.
						We strongly recommend you turn this back on.
					</p>
				)}

				<div className="button-container">
					<button
						className="comms padding-button-medium button-background-shading"
						onClick={handleClick}
					>
						Ignore
					</button>
					<button
						className={classNames(
							'stream',
							'padding-button-medium button-background-shading text-transform-capitalize',
						)}
						onClick={goToSettings}
					>
						Turn Backstage comms on
					</button>
				</div>
			</div>
		</div>
	);
}
